// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/RightSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var RightSquareTwoTone = function RightSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareTwoToneSvg
  }));
};

RightSquareTwoTone.displayName = 'RightSquareTwoTone';
export default React.forwardRef(RightSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RightSquareTwoTone.js
// module id = 1719
// module chunks = 0